import { render, staticRenderFns } from "./wxmpUserDetail.vue?vue&type=template&id=86df9cc6&scoped=true"
import script from "./wxmpUserDetail.vue?vue&type=script&lang=js"
export * from "./wxmpUserDetail.vue?vue&type=script&lang=js"
import style0 from "./wxmpUserDetail.vue?vue&type=style&index=0&id=86df9cc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86df9cc6",
  null
  
)

export default component.exports